module.exports = __webpack_public_path__ + "static/media/303KnobBackground.5ca3e157.svg";